module.exports = __webpack_public_path__ + "img/dropdown-filter-black.7eb8a8f4.png";